import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { UserPlus } from 'lucide-react';
import { TabsContent } from '@/components/ui/Tabs.tsx';
import TabScreen from '@/components/ui/TabScreen.tsx';
import {
  ACCESS_TABS,
  accessRoute,
  AccessTab,
} from '@/features/dashboard/access/routes/accessRoute.ts';
import UsersTable from '@/features/dashboard/access/components/UsersTable.tsx';
import InvitationsTable from '@/features/dashboard/access/components/InvitationsTable.tsx';
import InviteUserModal from '@/features/dashboard/access/components/InviteUserModal.tsx';

const AccessPage = () => {
  const { tab } = accessRoute.useSearch();
  const navigate = useNavigate();
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);

  return (
    <>
      <TabScreen
        tabs={ACCESS_TABS}
        value={tab}
        onChange={(value) =>
          navigate({ to: '/app/access', search: { tab: value } })
        }
        title="Dostęp"
        menuDescription="Osoby pracujące w panelu firmy. Wybierz sekcję."
        primaryAction={{
          label: 'Zaproś użytkownika',
          icon: UserPlus,
          onClick: () => setIsInviteModalOpen(true),
        }}
      >
        <TabsContent value={AccessTab.CURRENT}>
          <UsersTable />
        </TabsContent>
        <TabsContent value={AccessTab.INVITED}>
          <InvitationsTable />
        </TabsContent>
      </TabScreen>

      {isInviteModalOpen && (
        <InviteUserModal onClose={() => setIsInviteModalOpen(false)} />
      )}
    </>
  );
};

export default AccessPage;
